import React, { useState } from 'react';
import { ReferenceField, TextField } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import amezonlogo from '../../images/amazonLogo.svg';

const useStyles = makeStyles(() => ({
  titleFontWeight: {
    fontWeight: 700,
  },
  subtitle: {
    marginLeft: 16,
  },
  employeeName: {
    color: '#919EAB',
  },
}));
const UnifiedViewTopbar = ({ ...rest }) => {
  const { record } = rest;
  const {
    box,
    created_at,
    created_by_employee_id,
    customer,
    customer_address,
    client_location,
    status,
    health_check_url,
    date,
    service_vehicle_name,
    waitlist_note,
    keyosk,
    parking,
    hc_is_complete,
    vehicle,
    location_type,
    st_order_id,
    service_order_id,
    source,
  } = record;
  const { is_fleet_user, fleet_account_name } = customer || {};
  const classes = useStyles();
  const created = moment.utc(created_at).local();
  const createdString = created.format('YYYY-MM-DD hh:mm:ss A');
  const createdTimeAgo = created.fromNow();
  const history = useHistory();
  const handleBackClick = () => {
    // Check if there's history and if the previous page is from the same origin
    try {
      const prevPage = document.referrer;
      const isSameOrigin =
        prevPage && prevPage.startsWith(window.location.origin);
      if (history.length > 1 && isSameOrigin) {
        history.goBack();
      } else {
        // If no history or external referrer, navigate to scheduled work page
        history.push('/scheduled-work/');
      }
    } catch (e) {
      // Fallback if there's any issue checking the referrer
      history.push('/scheduled-work/');
    }
  };

  const SourceImgField = ({ }) => {
    const SourceType = source;

    let sourceImg = (
      <svg
        className="tool_icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.6888 18.6688L16.3888 13.3688H15.3988L12.8588 15.9088V16.8988L18.1588 22.1988C18.5488 22.5888 19.1788 22.5888 19.5688 22.1988L21.6888 20.0788C22.0788 19.6988 22.0788 19.0588 21.6888 18.6688ZM18.8588 20.0888L14.6188 15.8488L15.3288 15.1388L19.5688 19.3788L18.8588 20.0888Z"
          fill="black"
        />
        <path
          d="M17.3588 10.6888L18.7688 9.27878L20.8888 11.3988C22.0588 10.2288 22.0588 8.32878 20.8888 7.15878L17.3488 3.61878L15.9388 5.02878V2.20878L15.2388 1.49878L11.6988 5.03878L12.4088 5.74878H15.2388L13.8288 7.15878L14.8888 8.21878L11.9988 11.1088L7.8688 6.97878V5.55878L4.8488 2.53878L2.0188 5.36878L5.0488 8.39878H6.4588L10.5888 12.5288L9.7388 13.3788H7.6188L2.3188 18.6788C1.9288 19.0688 1.9288 19.6988 2.3188 20.0888L4.4388 22.2088C4.8288 22.5988 5.4588 22.5988 5.8488 22.2088L11.1488 16.9088V14.7888L16.2988 9.63878L17.3588 10.6888ZM9.3788 15.8388L5.1388 20.0788L4.4288 19.3688L8.6688 15.1288L9.3788 15.8388Z"
          fill="black"
        />
      </svg>
    );
    let imgClass = 'tool_icon_box';
  
    if (SourceType == "InShop") {
      sourceImg = <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#919EAB" fill-opacity="0.24" />
        <rect x="0.5" y="0.5" width="47" height="47" rx="7.5" stroke="#919EAB" stroke-opacity="0.24" />
        <path d="M13.0547 30.76V20.7903H33.9483V30.76" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.0195 30.76V24.5134H25.3889V30.76" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.25 20.75H34.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M31.8949 30.7601V25.5986H29.1289V30.7601" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.0195 25.7754H25.3889" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.0195 27.0208H25.3889" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.0195 28.2671H25.3889" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.0195 29.5122H25.3889" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M23.7601 16.5H18.0767C17.8445 16.5 17.6562 16.686 17.6562 16.9155V18.6411C17.6562 18.8706 17.8445 19.0566 18.0767 19.0566H23.7601C23.9923 19.0566 24.1805 18.8706 24.1805 18.6411V16.9155C24.1805 16.686 23.9923 16.5 23.7601 16.5Z" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18.8418 19.5569V20.3568" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M23.1289 19.5569V20.3568" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        <rect x="11" y="31.332" width="25" height="0.667463" fill="#181818" />
      </svg>;
    }
  
    if (SourceType == "MSS") {
      sourceImg = <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#919EAB" fill-opacity="0.24" />
        <rect x="0.5" y="0.5" width="47" height="47" rx="7.5" stroke="#919EAB" stroke-opacity="0.24" />
        <path d="M31.5001 19C30.6763 17.767 29.5605 16.7567 28.2521 16.0588C26.9436 15.361 25.483 14.9973 24.0001 15C22.5198 14.9991 21.0621 15.3637 19.7565 16.0615C18.4509 16.7593 17.3379 17.7687 16.5161 19M23.5001 15C22.7207 16.2486 22.1069 17.5932 21.6741 19M24.5 15C25.2801 16.2485 25.8945 17.5931 26.328 19M31.5001 29C30.6763 30.233 29.5605 31.2434 28.2521 31.9412C26.9436 32.639 25.483 33.0027 24.0001 33C22.5198 33.0009 21.0621 32.6363 19.7565 31.9385C18.4509 31.2407 17.3379 30.2313 16.5161 29M23.5001 33C22.7207 31.7514 22.1069 30.4068 21.6741 29M24.5 33C25.2801 31.7515 25.8945 30.4069 26.328 29M14 22L15 26L16.5 22L18 26L19 22M29 22L30 26L31.5 22L33 26L34 22M21.5 22L22.5 26L24 22L25.5 26L26.5 22" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>;
    }
  
    if (SourceType == "Amazon") {
      sourceImg = <img src={amezonlogo} alt="Company logo" width="48" height="48" />;
    }
    
    if (SourceType == "Simple") {
      sourceImg = <svg className="st_icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M13.3019 17.4409V11.2601H18.486C18.4895 11.3407 18.4907 11.4212 18.4907 11.5018C18.4907 14.5039 16.2662 17.0416 13.3019 17.4409ZM19.7817 9.70808L19.7675 9.6524L6.79254 9.65003C7.59618 7.168 9.87491 5.50699 12.4959 5.50699C14.4595 5.50699 16.2674 6.4536 17.392 8.04944H19.1468C17.8499 5.54846 15.321 4 12.4959 4C8.4659 4 5.17347 7.15023 5 11.1866V11.2601H11.6922V17.4409C9.21525 17.1092 7.23035 15.2894 6.66745 12.863H5.12509C5.77885 16.4291 8.84234 19 12.4959 19C16.6309 19 19.9976 15.6365 20 11.5018C20 10.8928 19.9268 10.2898 19.7817 9.70808Z"
          fill="#181818"
        />
      </svg>;
      imgClass = 'st_icon_box';
    }
    return <Box className={imgClass}>{sourceImg}</Box>;
  };

  return (
    <>
      <Grid
        item
        xs={12}
        md={12}
        xl={12}
        style={{ marginTop: 60, marginBottom: 40 }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className="appointment_detail_header"
        >
          <Box display="flex">
            <Box>
              <IconButton className="back_btn" onClick={handleBackClick}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M11.5247 15.8333C11.2726 15.8341 11.0336 15.7208 10.8747 15.5249L6.84973 10.5249C6.59697 10.2174 6.59697 9.77409 6.84973 9.46659L11.0164 4.46659C11.3109 4.11221 11.837 4.0637 12.1914 4.35826C12.5458 4.65281 12.5943 5.17887 12.2997 5.53326L8.57473 9.99992L12.1747 14.4666C12.3828 14.7164 12.4266 15.0643 12.287 15.3579C12.1474 15.6515 11.8498 15.8371 11.5247 15.8333Z"
                    fill="#637381"
                  />
                </svg>
              </IconButton>
            </Box>
            <Box>
              <Typography
                variant="h3"
                component="h1"
                className={classes.titleFontWeight}
              >
                {customer.first_name} {customer.last_name}
              </Typography>
              <Box className="appointment_number">
                {/* {st_order_id === null || st_order_id === 0 ? null : (
                  <Typography variant="body2">
                    <span>ST Order Id {st_order_id === 'NA' ? st_order_id : `#${st_order_id}`}</span>
                  </Typography>
                )} */}

                {service_order_id &&
                  service_order_id !== '0' && (
                    <Typography variant="body2">
                      <span>{`Amazon service ID #${service_order_id}`}</span>
                    </Typography>
                  )}
                {st_order_id > 0 && (
                  <Typography variant="body2">
                    <span>
                      {source === "MSS"
                        ? `MSS order ID #${st_order_id}`
                        : `ST order ID #${st_order_id}`}
                    </span>
                  </Typography>
                )}
              </Box>
              <Box
                display="flex"
                alignItems="center"
                className="appointment_content"
              >
                <Typography variant="body2">
                  <span>Created: {createdTimeAgo}</span>
                </Typography>
                <Typography variant="body2" className={classes.subtitle}>
                  <span>
                    {created_by_employee_id ? (
                      <ReferenceField
                        source="created_by_employee_id"
                        reference="employee"
                        {...rest}
                      >
                        <TextField
                          source="email_address"
                          className={classes.employeeName}
                        />
                      </ReferenceField>
                    ) : (
                      `Customer`
                    )}
                  </span>
                </Typography>
              </Box>
            </Box>
          </Box>
          <SourceImgField />
        </Box>
      </Grid>
    </>
  );
};

export default UnifiedViewTopbar;
